import { render, staticRenderFns } from "./PainPointTextBox.vue?vue&type=template&id=2b078392&scoped=true&"
import script from "./PainPointTextBox.vue?vue&type=script&lang=js&"
export * from "./PainPointTextBox.vue?vue&type=script&lang=js&"
import style0 from "./PainPointTextBox.vue?vue&type=style&index=0&id=2b078392&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b078392",
  null
  
)

export default component.exports